<template>
  <div class="user">
    <div class="info">
      <info :infos="baseInfo" :title="'基本信息'"></info>
      <div class="split"></div>
      <info :infos="realInfo" :title="'更多信息'"></info>
    </div>
    <div class="button">
      <my_button :value="'修改密码'" :inputStyle="buttonStyle" @click.native="password"></my_button>
      <!-- <my_button :value="certify" :inputStyle="buttonStyle" @click.native="certification"></my_button> -->
      <my_button :value="'修改资料'" :inputStyle="buttonStyle" @click.native="modifyInfo"></my_button>
      <my_button :value="'退出登录'" :inputStyle="buttonStyle" @click.native="logout"></my_button>
    </div>
    <div>大赛组委会将对参赛选手个人信息严格保密</div>
    <div>若报名基本信息有误，请联系微信客服修改</div>
  </div>
</template>

<script>
 // @ is an alias to /src
 import Info from '@/components/Info.vue'
 import MyButton from '@/components/Button.vue'

 export default {
   name: 'User',
   computed :{
     user (){
       return this.$store.state.auth.user
     },
     certify() {
       return this.user.realname ? '重新认证' : "实名认证"
     },
     group() {
       let gp = [0, '小学组', '初中组', '高中组']
       return gp[this.user.group]
     },
     buttonStyle(){
       return {
         width: '6em',
         height: '2vw',
         'font-size': '0.85vw',
         'border-radius': '0.5em',
       }
     },
     baseInfo(){
       return {
         '姓名': this.user.name,
         '是否报名': this.user.enrolled? '是': '否',
         '参赛地区': this.user.area,
       }
     },
     realInfo(){
       return{
         /* '真实姓名': this.user.name, */
         /* '身份证号': this.user.idcard, */
         '报名id': this.user.phone,
         '参赛单位': this.user.organization? this.user.organization:  '无',
         '参赛组别': this.group
         /* '指导老师': this.user.teacher ? this.user.teacher : '无' */
       }
     }
   },
   methods: {
     password() {
       this.$router.push({name: 'account', params:{type: "password"}})
     },
     certification () {
       this.$router.push({name: 'account', params: {type: 'certify'}})
     },
     modifyInfo() {
       this.$router.push({name: 'account', params: {type: 'modify'}})
     },
     logout() {
       this.$http.post('/api/login/logout')
         .then(res => {
           this.$store.commit("LOGOUT");
           this.$router.replace({name: 'account', params:{type: "login"}})
         })
     }
   },
   mounted() {

   },
   components: {
     info: Info,
     my_button: MyButton
   }
 }
</script>

<style scoped>
 .split{
   width: 2px;
   margin-top: 5%;
   height: 60%;
   background-color: rgba(0,0,0, 0.6);
 }
 .info{
   width: 100vw;
   margin-top: 4vw;
   height: 46vh;
   display: flex;
   align-items: center;
   justify-content: space-around;
 }
 .user{
   display: flex;
   flex-direction: column;
   align-items:center;
   padding-bottom: 5vh;
 }
 .button{
   display: flex;
   align-items:center;
   justify-content: space-between;
   width: 60vw;
   margin-bottom: 5vh;
   margin-top: 2vh;
 }
</style>
